<div class="trophy">
    <h3 class="trophy__announcer">{{header() | translate}}</h3>

    @if(data(); as prize){
        <div class="trophy__img">
            <img [src]="prize.img" alt="" class="" height="148">
        </div>

        @switch(prize.type){
            @case ('bonuses'){
                <p class="trophy__title">{{'WHEEL.TROPHY.PRIZE_BONUSES' | translate: {bonuses: prize.name} }}</p>
            }

            @case ('spins') {
                <p class="trophy__title">{{'WHEEL.TROPHY.PRIZE_SPINS' | translate: {spins: prize.name} }}</p>
            }

            @case ('product'){
                <p class="trophy__title">{{ prize.name }}</p>
            }
        }
        @if(showExpDate){
            <p class="trophy__expiration">{{'WHEEL.TROPHY.EXPIRATION_TERM' | translate: {days: prize.days} }}</p>
        }
        
    }
</div>